import React, { Component } from 'react';

class Quality extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comment: this.props.ratingObject.comment || '',
      rating: this.props.ratingObject.rating || 0
    };
  }

  saveChanges = () => {
    this.props.saveRating(this.props.ratingObject.id, {comment: this.state.comment, value: this.state.rating});
  }

  render() {
    var qualityvalues = [
      {name: 0, value: 0}, {name: 1, value: 1}, {name: 2, value: 2}, {name: 3, value: 3}, {name: 4, value: 4}, {name: 5, value: 5},{name: 6, value: 6}
    ];
    var change = (key, evt) => {
      var obj = {};
      obj[key] = evt.currentTarget.value;
      this.setState(obj);

      var textarea = this.textarea;
      textarea.style.height = 0;
      textarea.style.height = textarea.scrollHeight + 5;
    };
    var textAreaStyle = {width: "100%", minHeight: 30, marginTop: "2px", resize: "none"};
    var h1Styling = {fontSize: 12, color: "#333", fontWeight: "bold"};
    return (
      <div style={{padding: 15}}>
        <h1 style={h1Styling}>{this.props.ratingObject.name}</h1>
        <select onBlur={this.saveChanges} onChange={change.bind(null, 'rating')} style={{width: '60px'}} value={this.state.rating}>
          {qualityvalues.map((item) => (
            <option key={item.value} value={item.value}> {item.name}</option>
          ))}
        </select>
        <br /><br />
        <h1 style={h1Styling}>Comment</h1>
        <textarea
          style={textAreaStyle}
          onChange={change.bind(null, 'comment')}
          onBlur={this.saveChanges}
          value={this.state.comment}
          ref={(node) => this.textarea = node}
        />
      </div>
    );
  }
}

export { Quality };
